import { useContext } from 'react';
import { ModalProviderContext } from '../components/ModalProvider';

export const useCloseParentModal = (onClose: () => void) => {
  const { modals } = useContext(ModalProviderContext);

  return () => {
    if (modals.length <= 1) {
      onClose();
    }
  };
};
